export default __webpack_public_path__ + "static/media/DailyBonus_PopupSound.351467ce.mp3";